import styled from 'styled-components';
import { Button } from '@payright/web-components';

import SCSpinner from '../../components/spinner';
import { AppThunkDispatch } from '../../util/store';
import { useDispatch } from 'react-redux';

type SaveButtonProps = {
  loading: boolean;
  depositTaker: boolean;
  depositAmount: number;
  mode: string;
  checkoutId: string;
  redirectUrl: string;
  checkoutType: string;
  checkoutStep: string;
  hasValidCardSelected?: boolean;
  depositPaymentStatus: string | undefined;
};

const SCSaveButton = styled.div`
  margin-top: 10px;
  .next-button {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
`;

export const getSaveButtonText = (
  depositTaker: boolean,
  depositAmount: number,
  checkoutType: string,
  checkoutStep: string,
  depositPaymentStatus: string | undefined
) => {
  if (depositPaymentStatus || depositAmount === 0) return 'Save and continue';
  if (depositTaker && depositAmount > 0) return 'Save and confirm deposit payment to merchant';
  if (checkoutType === 'pre-approval' && checkoutStep !== 'pre-approval-payment') return 'Save';
  return 'Save details and pay deposit';
};

const SaveButton = ({
  loading,
  depositTaker,
  depositAmount,
  mode,
  checkoutId,
  redirectUrl,
  checkoutType,
  checkoutStep,
  hasValidCardSelected,
  depositPaymentStatus,
}: SaveButtonProps) => {
  return (
    <SCSaveButton>
      <Button
        className="next-button"
        withShadow
        disabled={loading || (mode === 'existing' && !hasValidCardSelected)}
        iconPosition="right"
        icon={loading ? <SCSpinner /> : undefined}
        type="submit"
        maxWidth={'100%'}
        colour="primary"
      >
        {getSaveButtonText(
          depositTaker,
          depositAmount,
          checkoutType,
          checkoutStep,
          depositPaymentStatus
        )}
      </Button>
    </SCSaveButton>
  );
};

export default SaveButton;
